import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  
  // If the user is not logged in, redirect to the login page
  if (!token) {
    return <Navigate to="/" />;
  }

  // Otherwise, render the child components (the private page)
  return children;
};

export default PrivateRoute;
